import React from 'react';

export const Hamburger = props => {
  return <div className={'ham-x '+(props.open ? 'open':'')}>
    <span className='top'></span>
    <span className='mid'></span>
    <span className='bottom'></span>
  </div>
}
